import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    MORE_GET_PRODUCTS_SUCCESS,
    MORE_GET_PRODUCTS_FAILURE,
} from 'src/pages/more/pages/productGuide/redux/action/actionTypes';
import { errorHandler } from 'src/errorHandler/errorHandler';

import { convertObjectToQueryParams } from 'src/utils/util';

export default function* searchProducts(action) {
    const { countryISOCode } = yield select((state) => ({
        countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode
    }));
    let url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productList?`;
    const queryParams = action.payload;

    const token = queryParams.cancelSearchToken;
    queryParams.isMastOrder = false;
    delete queryParams.cancelSearchToken;
    if (queryParams) url = `${url}${convertObjectToQueryParams(queryParams)}`;

    try {
        const result = yield axios
            .get(url, { cancelToken: token })
            .then((response) => response.data);
        yield put({
            type: MORE_GET_PRODUCTS_SUCCESS,
            products: result.productsList || [],
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            totalRecordsCount: result.productsTotalCount,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: MORE_GET_PRODUCTS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
